import { lazy } from "react";
import { Lazy } from "../Lazy/Lazy";

const MyWaitlist = lazy(() => import("./MyWaitlist"));

/** Route shell for /my-waitlist, kept as thin as the page underneath it. */
export default function WaitlistWrapper() {
  return (
    <Lazy>
      <MyWaitlist />
    </Lazy>
  );
}
